import axios from 'axios';

export function createMfaBearerClient(bearerToken) {
    return axios.create({
        baseURL: '/api',
        withCredentials: true,
        headers: {
            Authorization: `Bearer ${bearerToken}`,
        },
    });
}
